/*
Controller: DropShip

Operations:
  createDropShip
  getDropShip
  getDropShipById
  patchDropShip
  deleteDropShip
  submitDropShip
  createDropShipFiles
  updateDropShipFiles
  deleteDropShipFiles
*/
var Api = require('../config')
var CreateDropShipRequestDef = require('../definitions/CreateDropShipRequest')
var PatchDropShipRequestDef = require('../definitions/PatchDropShipRequest')
var DropShipFilesRequestDef = require('../definitions/DropShipFilesRequest')
var DeleteDropShipFilesRequestDef = require('../definitions/DeleteDropShipFilesRequest')

var DropShip = (function () {
  /*
  Operation: createDropShip
  
  Parameters:

  Responses:
    HTTP 200: Successful operation
    HTTP 400: Invalid payload
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 409: Project name already exists
    HTTP 500: Server error
  */
  function createDropShipDropShip (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        CreateDropShipRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/dropShip'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getDropShip
  
  Parameters:







  Responses:
    HTTP 200: Successful operation
    HTTP 400: Invalid payload
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 500: Server error
  */
  function getDropShipDropShip (dropShipType, status, page, perPage, sortBy, sortDirection, search) {
    return new Promise(function (resolve, reject) {
      try {
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters['dropShipType'] = dropShipType
      parameters['status'] = status
      parameters['page'] = page
      parameters['perPage'] = perPage
      parameters['sortBy'] = sortBy
      parameters['sortDirection'] = sortDirection
      parameters['search'] = search
      var path = '/dropShip'
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getDropShipById
  
  Parameters:

  Responses:
    HTTP 200: Successful operation
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Not Found
    HTTP 500: Server error
  */
  function getDropShipByIdDropShip (id) {
    return new Promise(function (resolve, reject) {
      try {
        if (!id) {
          throw new Error('id: Missing parameter')
        }
        if (id && !(typeof id === 'string')) {
          throw new Error('id: Wrong type: Got "' + (typeof id) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/dropShip/{id}'
      path = path.replace('{' + 'id' + '}', id)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: patchDropShip
  
  Parameters:


  Responses:
    HTTP 200: Successful operation
    HTTP 400: Invalid payload
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Not Found
    HTTP 409: Project name already exists
    HTTP 500: Server error
  */
  function patchDropShipDropShip (id, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!id) {
          throw new Error('id: Missing parameter')
        }
        if (id && !(typeof id === 'string')) {
          throw new Error('id: Wrong type: Got "' + (typeof id) + '", but expected: "string"')
        }
        PatchDropShipRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/dropShip/{id}'
      path = path.replace('{' + 'id' + '}', id)
      Api
        .request({
          url: path,
          method: 'patch',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: deleteDropShip
  
  Parameters:

  Responses:
    HTTP 200: Successful operation
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Not Found
    HTTP 500: Server error
  */
  function deleteDropShipDropShip (id) {
    return new Promise(function (resolve, reject) {
      try {
        if (!id) {
          throw new Error('id: Missing parameter')
        }
        if (id && !(typeof id === 'string')) {
          throw new Error('id: Wrong type: Got "' + (typeof id) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/dropShip/{id}'
      path = path.replace('{' + 'id' + '}', id)
      Api
        .request({
          url: path,
          method: 'delete',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: submitDropShip
  
  Parameters:

  Responses:
    HTTP 200: Successful operation
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Not Found
    HTTP 500: Server error
  */
  function submitDropShipDropShip (id) {
    return new Promise(function (resolve, reject) {
      try {
        if (!id) {
          throw new Error('id: Missing parameter')
        }
        if (id && !(typeof id === 'string')) {
          throw new Error('id: Wrong type: Got "' + (typeof id) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/dropShip/{id}/submit'
      path = path.replace('{' + 'id' + '}', id)
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: createDropShipFiles
  
  Parameters:


  Responses:
    HTTP 200: Successful operation
    HTTP 400: Invalid payload
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Not Found
    HTTP 500: Server error
  */
  function createDropShipFilesDropShip (dropShipId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!dropShipId) {
          throw new Error('dropShipId: Missing parameter')
        }
        if (dropShipId && !(typeof dropShipId === 'string')) {
          throw new Error('dropShipId: Wrong type: Got "' + (typeof dropShipId) + '", but expected: "string"')
        }
        DropShipFilesRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/dropShip/{dropShipId}/files'
      path = path.replace('{' + 'dropShipId' + '}', dropShipId)
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: updateDropShipFiles
  
  Parameters:


  Responses:
    HTTP 200: Successful operation
    HTTP 400: Invalid payload
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Not Found
    HTTP 500: Server error
  */
  function updateDropShipFilesDropShip (dropShipId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!dropShipId) {
          throw new Error('dropShipId: Missing parameter')
        }
        if (dropShipId && !(typeof dropShipId === 'string')) {
          throw new Error('dropShipId: Wrong type: Got "' + (typeof dropShipId) + '", but expected: "string"')
        }
        DropShipFilesRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/dropShip/{dropShipId}/files'
      path = path.replace('{' + 'dropShipId' + '}', dropShipId)
      Api
        .request({
          url: path,
          method: 'put',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: deleteDropShipFiles
  
  Parameters:


  Responses:
    HTTP 200: Successful operation
    HTTP 400: Invalid payload
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Not Found
    HTTP 500: Server error
  */
  function deleteDropShipFilesDropShip (dropShipId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!dropShipId) {
          throw new Error('dropShipId: Missing parameter')
        }
        if (dropShipId && !(typeof dropShipId === 'string')) {
          throw new Error('dropShipId: Wrong type: Got "' + (typeof dropShipId) + '", but expected: "string"')
        }
        DeleteDropShipFilesRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/dropShip/{dropShipId}/files/delete'
      path = path.replace('{' + 'dropShipId' + '}', dropShipId)
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['createDropShip'] = createDropShipDropShip
  ret['getDropShip'] = getDropShipDropShip
  ret['getDropShipById'] = getDropShipByIdDropShip
  ret['patchDropShip'] = patchDropShipDropShip
  ret['deleteDropShip'] = deleteDropShipDropShip
  ret['submitDropShip'] = submitDropShipDropShip
  ret['createDropShipFiles'] = createDropShipFilesDropShip
  ret['updateDropShipFiles'] = updateDropShipFilesDropShip
  ret['deleteDropShipFiles'] = deleteDropShipFilesDropShip
  return ret
})()

module.exports = DropShip
